import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/analytics';

var firebaseConfig = {
  apiKey: "AIzaSyCuplny5hz7Oq4P1k-I6cpBEdSs2NykkeA",
  authDomain: "touristy-2be13.firebaseapp.com",
  projectId: "touristy-2be13",
  databaseURL: "https://touristy-2be13-default-rtdb.firebaseio.com/",
  storageBucket: "touristy-2be13.appspot.com",
  messagingSenderId: "160724898180",
  appId: "1:160724898180:web:aafedb666e5a7cb66a0dd1",
  measurementId: "G-J3RXRWJP63"
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
